import { RouterModule } from '@angular/router';
import { DoctorComponent } from './../modules/doctor/doctor.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionItemComponent } from './components/session-item/session-item.component';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { DefaultImageDirective } from './directives/default-image.directive';
import { RateComponent } from './components/rate/rate.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SuccessStoryComponent } from './components/success-story/success-story.component';
import { HealthEducationComponent } from './components/health-education/health-education.component';
import { TeamMemberComponent } from './components/team-member/team-member.component';
import { FaqComponent } from './components/faq/faq.component';
import { NewItemComponent } from './components/new-item/new-item.component';
import { ConsultationComponent } from './components/consultation/consultation.component';
import { CalenderComponent } from './components/calender/calender.component';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppPasswordDirective } from './directives/app-password.directive';

@NgModule({
  declarations: [
    SessionItemComponent,
    DefaultImageDirective,
    RateComponent,
    SuccessStoryComponent,
    HealthEducationComponent,
    TeamMemberComponent,
    FaqComponent,
    NewItemComponent,
    CalenderComponent,
    ConsultationComponent,
    AppPasswordDirective,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule,
    RouterModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  exports: [
    SessionItemComponent,
    HealthEducationComponent,
    NewItemComponent,
    SuccessStoryComponent,
    TeamMemberComponent,
    AngularSvgIconModule,
    DefaultImageDirective,
    RateComponent,
    TranslateModule,
    FaqComponent,
    ConsultationComponent,
    CalenderComponent,
    AppPasswordDirective,
  ],
})
export class SharedModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
